export const environment = {
  WS_GRAPHQL_ENDPOINT: 'ws://api.np.traintogo.de/graphql',
  HTTP_GRAPHQL_ENDPOINT: 'https://api.np.traintogo.de/graphql',
  AUTH0_GRAPHQL_AUDIENCE: 'https://graphql.np.ppm.wellyou.de',
  AUTH0_DOMAIN: 'ppm-wellyou-np.eu.auth0.com',
  AUTH0_CLIENT_ID: 'QWjviLCoBkCLG8rYCVYYeWF545RUXD7x',
  STAGE: 'np',
  HOST: 'admin.np.traintogo.de',
  ASSET_URL:
    'https://ppm-assets-np.s3.eu-central-1.amazonaws.com/traintogo-admin-dashboard/public/assets',
};
